import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import Stack from "@mui/material/Stack";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Check from "@mui/icons-material/Check";
import ModeStandbyIcon from "@mui/icons-material/ModeStandby";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import AddressInfo from "../address-info/address-info";
import BusinessInformation from "../business-info/business-info";
import ContactInfo from "../contact-info/contact-info";
import PrimaryUserInfo from "../primary-userinfo/primary-userinfo";
import { useLocation, useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Footer from "../../reusable-components/footer/footer";
import axios from "axios";
import "./newregisteration.css";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import BaseUrl from "../../utils/base-uri.json";
import RegistrationSuccess from "./RegistrationSuccess";
import { ToastContainer, toast } from "react-toastify";

// const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
//   [`&.${stepConnectorClasses.alternativeLabel}`]: {
//     top: 8,
//     width: 250,
//     left: -130
//   },
//   [`&.${stepConnectorClasses.active}`]: {
//     [`& .${stepConnectorClasses.line}`]: {
//       backgroundColor: "#2A93DB"
//     }
//   },
//   [`&.${stepConnectorClasses.completed}`]: {
//     [`& .${stepConnectorClasses.line}`]: {
//       backgroundColor: "#2A93DB"
//     }
//   },
//   [`& .${stepConnectorClasses.line}`]: {
//     height: 3,
//     border: 0,
//     backgroundColor:
//       theme.palette.mode === "dark" ? theme.palette.grey[800] : "#eaeaf0",
//     borderRadius: 1
//   }
// }));

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: "calc(-50% + 16px)",
    right: "calc(50% + 16px)",
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: "#2A93DB",
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: "#2A93DB",
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor:
      theme.palette.mode === "dark" ? theme.palette.grey[800] : "#eaeaf0",
    borderTopWidth: 3,
    borderRadius: 1,
  },
}));

const ColorlibStepIconRoot = styled("div")(({ theme, ownerState }) => ({
  backgroundColor:
    theme.palette.mode === "dark" ? theme.palette.grey[700] : "#ccc",
  zIndex: 1,
  color: "#fff",
  width: 20,
  height: 20,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  ...(ownerState.active && {
    backgroundColor: "#2A93DB",
    color: "white",
    boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
  }),
  ...(ownerState.completed && {
    backgroundColor: "#2A93DB",
    color: "white",
  }),
}));

function ColorlibStepIcon(props) {
  const { active, completed, className } = props;
  // console.log('this is the props: ', props);
  const icons = {
    1: <ModeStandbyIcon />,
    2: <ModeStandbyIcon />,
    3: <ModeStandbyIcon />,
    4: <ModeStandbyIcon />,
  };

  return (
    <ColorlibStepIconRoot
      ownerState={{ completed, active }}
      className={className}
    >
      {icons[String(props.icon)]}
    </ColorlibStepIconRoot>
  );
}

ColorlibStepIcon.propTypes = {
  /**
   * Whether this step is active.
   * @default false
   */
  active: PropTypes.bool,
  className: PropTypes.string,
  /**
   * Mark the step as completed. Is passed to child components.
   * @default false
   */
  completed: PropTypes.bool,
  /**
   * The label displayed in the step icon.
   */
  icon: PropTypes.node,
};

const steps = [
  "Business Information",
  "Address Information",
  "Contact Information",
  "Primary User Information",
];

export default function Newregisteration(props) {
  const [activeStep, setActiveStep] = React.useState(0);
  const [completed, setCompleted] = React.useState({});
  const [legalName, setLegalName] = React.useState("");
  const [taxIdValue, settaxIdValue] = React.useState("");
  const [principalValue, setprincipalValue] = React.useState("");
  const [addressLine1Value, setAddressLine1Value] = React.useState("");
  const [CountrySelectedForm, setCountrySelectedForm] = React.useState("");
  const [StateSelectedForm, setStateSelectedForm] = React.useState("");
  const [CitesForm, setCitesForm] = React.useState("");

  const [ZipCodeForm, setZipCodeForm] = React.useState("");
  const [languageForm, setlanguageForm] = React.useState("");
  const [RegionsForm, setRegionsForm] = React.useState("");
  const [PhoneNumber, setPhoneNumber] = React.useState("");
  const [PhoneExtension, setPhoneExtension] = React.useState("");
  const [FaxNumber, setFaxNumber] = React.useState("");
  const [WebsiteUrl, setWebsiteUrl] = React.useState("");
  const [firstName, setfirstName] = React.useState("");
  const [lastName, setlastName] = React.useState("");
  const [title, settitle] = React.useState("");
  const [phoneNumber, setphoneNumber] = React.useState("");
  const [emailAddress, setemailAddress] = React.useState("");
  const [password, setpassword] = React.useState("");
  const [confirmPassword, setconfirmPassword] = React.useState("");
  const [legalNameError, setLegalNameError] = React.useState("");
  const [openError, setOpenError] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [taxIdError, setTaxIdError] = React.useState("");
  const [companyPrincipleError, setCompanyPrincipalError] = React.useState("");
  const [addressLine1ValueError, setAddressLine1ValueError] =
    React.useState("");
  const [cityValueError, setCityValueError] = React.useState("");
  const [countrySelectedFormError, setCountrySelectedFormError] =
    React.useState("");

  const [zipCodeFormError, setZipCodeFormError] = React.useState("");
  const [phoneNumberError, setPhoneNumberError] = React.useState("");
  const [primaryPhoneNumberError, setPhoneNumberErrorPrimary] =
    React.useState("");
  const [phoneExtensionError, setPhoneExtensionError] = React.useState("");
  const [faxNumberError, setFaxNumberError] = React.useState("");
  const [WebsiteUrlError, setWebsiteUrlError] = React.useState("");
  const [firstNameError, setFirstNameError] = React.useState("");
  const [lastNameError, setLastNameError] = React.useState("");
  const [titleError, setTitleError] = React.useState("");
  const [passwordError, setPasswordError] = React.useState("");
  const [confirmPasswordError, setconfirmPasswordError] = React.useState("");
  const [emailAddressError, setEmailAddressError] = React.useState("");
  const [invitationId, setInivitationId] = useState(null);

  const [allFieldUpdated, setAllFieldUpdated] = React.useState(false);
  const [registrationSuccessfull, setRegistrationSuccessfull] =
    React.useState(false);

  const [checkBoxStatus, setCheckBoxStatus] = React.useState(true);
  const [checkBoxStatusError, setCheckBoxStatusError] = React.useState("");
  const [userDataFetched, setUserDataFetched] = useState(false);

  const [Dis, setDis] = React.useState(false);

  const navigate = useNavigate();
  // const Alert = React.forwardRef(function Alert(props, ref) {
  //   return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  // });

  const totalSteps = () => {
    return steps.length;
  };
  const completedSteps = () => {
    return Object.keys(completed).length;
  };
  const isLastStep = () => {
    return activeStep === totalSteps() - 1;
  };
  const allStepsCompleted = () => {
    return completedSteps() === totalSteps();
  };
  const handleNext = () => {
    const newActiveStep =
      isLastStep() && !allStepsCompleted()
        ? // It's the last step, but not all steps have been completed,
        // find the first step that has been completed
        steps.findIndex((step, i) => !(i in completed))
        : activeStep + 1;
    setActiveStep(newActiveStep);
  };
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
    setOpenError(false);
  };

  const location = useLocation();
  const search = location.search;

  useEffect(() => {
    if (search !== "") {
      axios
        .get(
          BaseUrl.baseUrl +
          BaseUrl.registration.invitedVendorRegistration +
          search
        )
        .then((res) => {
          const userData = res?.data?.data;
          setLegalName(userData.name);
          setAddressLine1Value(userData.address1);
          setCountrySelectedForm(userData.country);
          setStateSelectedForm(userData.state);
          setZipCodeForm(userData.zip);
          setCitesForm(userData.city);
          setfirstName(userData.firstName);
          setlastName(userData.lastName);
          setemailAddress(userData.email.split(",")[0]);
          setInivitationId(userData?.invitationId);
          setUserDataFetched(true);
        });
    }
  }, [search]);

  useEffect(() => {
    if (userDataFetched) {
      handleStep(0);
    }
  }, [userDataFetched]);

  const validateBusinessInfoForm = (legalName, taxIdValue, principalValue) => {
    if (
      legalName.length == 0 &&
      taxIdValue.length == 0 &&
      principalValue.length == 0
    ) {
      setOpenError(true);
      setLegalNameError("error");
      setTaxIdError("error");
      setCompanyPrincipalError("error");
    } else if (legalName.length == 0) {
      setOpenError(true);
      setLegalNameError("error");
    } else if (taxIdValue.length == 0) {
      setOpenError(true);
      setTaxIdError("error");
    } else if (principalValue.length == 0) {
      setOpenError(true);
      setCompanyPrincipalError("error");
    } else {
      return true;
    }
    return false;
  };

  const setBusinessInfostate = (legalName, taxIdValue, principalValue) => {
    setLegalName(legalName);
    settaxIdValue(taxIdValue);
    setprincipalValue(principalValue);
  };

  const setBusinessInfostates = (legalName, taxIdValue, principalValue) => {
    // var allRequiredFieldFilled = false;
    const allRequiredFieldFilled = validateBusinessInfoForm(
      legalName,
      taxIdValue,
      principalValue
    );
    if (allRequiredFieldFilled) {
      setBusinessInfostate(legalName, taxIdValue, principalValue);
      handleNext();
    } else {
      toast.error("Please enter mandatory fields", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
    // if (
    //   legalName.length == 0 &&
    //   taxIdValue.length == 0 &&
    //   principalValue.length == 0
    // ) {
    //   setOpenError(true);
    //   setLegalNameError("error");
    //   setTaxIdError("error");
    //   setCompanyPrincipalError("error");
    // } else if (legalName.length == 0) {
    //   setOpenError(true);
    //   setLegalNameError("error");
    // } else if (taxIdValue.length == 0) {
    //   setOpenError(true);
    //   setTaxIdError("error");
    // } else if (principalValue.length == 0) {
    //   setOpenError(true);
    //   setCompanyPrincipalError("error");
    // } else {
    //   allRequiredFieldFilled = true;
    //   // setLegalName(legalName);
    //   // settaxIdValue(taxIdValue);
    //   // setprincipalValue(principalValue);
    //   setBusinessInfostate(legalName, taxIdValue, principalValue);
    //   handleNext();
    // }
    // if (!allRequiredFieldFilled) {
    //   toast.error("Please enter mandatory fields", {
    //     position: "top-right",
    //     autoClose: 5000,
    //     hideProgressBar: false,
    //     closeOnClick: true,
    //     pauseOnHover: true,
    //     draggable: true,
    //     progress: undefined,
    //     theme: "light",
    //   });
    // }
  };

  const validateAddressInfoForm = (
    addressLine1Value,
    CountrySelectedForm,
    StateSelectedForm,
    CitesForm,
    ZipCodeForm,
    languageForm,
    RegionsForm
  ) => {
    if (
      typeof addressLine1Value == "undefined" &&
      typeof CountrySelectedForm == "undefined" &&
      typeof StateSelectedForm == "undefined" &&
      typeof CitesForm == "undefined" &&
      typeof ZipCodeForm == "undefined" &&
      typeof languageForm == "undefined" &&
      typeof RegionsForm == "undefined"
    ) {
      setOpenError(true);
      setAddressLine1ValueError("error");
      setZipCodeFormError("error");
      setCityValueError("error");
    } else if (typeof addressLine1Value == "undefined") {
      setOpenError(true);
      setAddressLine1ValueError("error");
    } else if (typeof ZipCodeForm == "undefined") {
      setOpenError(true);
      setZipCodeFormError("error");
    } else if (
      CitesForm == undefined ||
      CitesForm == "" ||
      StateSelectedForm == undefined ||
      StateSelectedForm == "" ||
      StateSelectedForm == "--Select States--" ||
      CountrySelectedForm == "--Select Country--" ||
      languageForm == undefined ||
      languageForm == "" ||
      languageForm == "selectLanguage" ||
      RegionsForm == undefined ||
      RegionsForm == "" ||
      RegionsForm == "--Vendor Operating Region--" ||
      addressLine1Value == "" ||
      ZipCodeForm == ""
    ) {
      //error
    } else {
      return true;
    }
    return false;
  };

  const setAddressInfoState = (
    addressLine1Value,
    CountrySelectedForm,
    StateSelectedForm,
    CitesForm,
    ZipCodeForm,
    languageForm,
    RegionsForm
  ) => {
    setAddressLine1Value(addressLine1Value);
    setCountrySelectedForm(CountrySelectedForm);
    setStateSelectedForm(StateSelectedForm);
    setCitesForm(CitesForm);
    setZipCodeForm(ZipCodeForm);
    setlanguageForm(languageForm);
    setRegionsForm(RegionsForm);
  };

  const setAddressInfoStates = (
    addressLine1Value,
    CountrySelectedForm,
    StateSelectedForm,
    CitesForm,
    ZipCodeForm,
    languageForm,
    RegionsForm,
    nextOrBack
  ) => {
    // var allRequiredFieldFilled = false;
    const allRequiredFieldFilled = validateAddressInfoForm(
      addressLine1Value,
      CountrySelectedForm,
      StateSelectedForm,
      CitesForm,
      ZipCodeForm,
      languageForm,
      RegionsForm
    );
    setAddressInfoState(
      addressLine1Value,
      CountrySelectedForm,
      StateSelectedForm,
      CitesForm,
      ZipCodeForm,
      languageForm,
      RegionsForm
    );
    if (nextOrBack === "next" && allRequiredFieldFilled) {
      handleNext();
      handleComplete();
    } else if (nextOrBack === "back") {
      handleBack();
      return;
    }
    if (!allRequiredFieldFilled) {
      toast.error("Please enter mandatory fields", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
    // if (
    //   typeof addressLine1Value == "undefined" &&
    //   typeof CountrySelectedForm == "undefined" &&
    //   typeof StateSelectedForm == "undefined" &&
    //   typeof CitesForm == "undefined" &&
    //   typeof ZipCodeForm == "undefined" &&
    //   typeof languageForm == "undefined" &&
    //   typeof RegionsForm == "undefined"
    // ) {
    //   setOpenError(true);
    //   setAddressLine1ValueError('error');
    //   setZipCodeFormError('error');
    //   setCityValueError("error")
    // } else if (typeof addressLine1Value == 'undefined') {
    //   setOpenError(true);
    //   setAddressLine1ValueError("error");
    // } else if (typeof ZipCodeForm == "undefined") {
    //   setAddressLine1ValueError('error');
    // } else if (typeof ZipCodeForm == "undefined") {
    //   setOpenError(true);
    //   setZipCodeFormError("error");
    // } else if (
    //   CitesForm == undefined ||
    //   CitesForm == "" ||
    //   StateSelectedForm == undefined ||
    //   StateSelectedForm == "" ||
    //   StateSelectedForm == "--Select States--" ||
    //   CountrySelectedForm == "--Select Country--" ||
    //   languageForm == undefined ||
    //   languageForm == "" ||
    //   RegionsForm == undefined ||
    //   RegionsForm == "" ||
    //   RegionsForm == "--Vendor Operating Region--"
    // ) {
    //   //error
    // }
    // else {
    //   allRequiredFieldFilled = true;
    //   // setAddressLine1Value(addressLine1Value);
    //   // setCountrySelectedForm(CountrySelectedForm);
    //   // setStateSelectedForm(StateSelectedForm);
    //   // setCitesForm(CitesForm);
    //   // setZipCodeForm(ZipCodeForm);
    //   // setlanguageForm(languageForm);
    //   // setRegionsForm(RegionsForm);
    //   // handleNext();
    //   setAddressInfoState(
    //     addressLine1Value,
    //     CountrySelectedForm,
    //     StateSelectedForm,
    //     CitesForm,
    //     ZipCodeForm,
    //     languageForm,
    //     RegionsForm
    //   );

    //   if (nextOrBack === "next") {
    //     handleNext();
    //     handleComplete();
    //   } else {
    //     handleBack();
    //   }
    // }
  };

  const validateContactInfoForm = (PhoneNumber) => {
    if (
      typeof PhoneNumber == "undefined" ||
      PhoneNumber.length == 0 ||
      phoneNumberError != "" ||
      (typeof faxNumberError != "undefined" && faxNumberError != "") ||
      (typeof phoneExtensionError == "undefined" && phoneExtensionError != "")
    ) {
      return false;
    } else return true;
  };

  const setContactInfoState = (
    PhoneNumber,
    PhoneExtension,
    FaxNumber,
    WebsiteUrl
  ) => {
    setPhoneNumber(PhoneNumber);
    setPhoneExtension(PhoneExtension);
    setFaxNumber(FaxNumber);
    setWebsiteUrl(WebsiteUrl);
  };

  const setContactInformationForm = (
    PhoneNumber,
    PhoneExtension,
    FaxNumber,
    WebsiteUrl,
    nextOrBack
  ) => {
    const allRequiredFieldFilled = validateContactInfoForm(PhoneNumber);
    setContactInfoState(PhoneNumber, PhoneExtension, FaxNumber, WebsiteUrl);
    if (nextOrBack === "next" && allRequiredFieldFilled) {
      handleNext();
      handleComplete();
    } else if (nextOrBack === "back") {
      handleBack();
      return;
    }
    //  var allRequiredFieldFilled = false;
    // if ((typeof PhoneNumber == 'undefined' || PhoneNumber.length == 0) && (typeof PhoneExtension == 'undefined' || PhoneExtension.length == 0) && (typeof FaxNumber == 'undefined' || FaxNumber.length == 0) && (typeof WebsiteUrl == 'undefined' || WebsiteUrl.length == 0)) {
    //   setOpenError(true);
    //   setPhoneNumberError('error');
    //   setPhoneExtensionError('error');
    //   setFaxNumberError('error');
    //   setWebsiteUrlError('error');
    // } else if (typeof PhoneNumber == 'undefined' || PhoneNumber.length == 0) {
    //   setOpenError(true);
    //   setPhoneNumberError('error');
    // } else if (typeof PhoneExtension == 'undefined' || PhoneExtension.length == 0) {
    //   setOpenError(true);
    //   setPhoneExtensionError('error');
    // } else if (typeof FaxNumber == 'undefined' || FaxNumber.length == 0) {
    //   setOpenError(true);
    //   setFaxNumberError('error');
    // } else if (typeof WebsiteUrl == 'undefined' || WebsiteUrl.length == 0) {
    //   setOpenError(true);
    //   setWebsiteUrlError('error');
    // }
    // if(typeof PhoneNumber == 'undefined' || PhoneNumber.length == 0 || phoneNumberError != ""){

    // }
    // else {
    //   allRequiredFieldFilled = true;
    //   // setPhoneNumber(PhoneNumber)
    //   // setPhoneExtension(PhoneExtension);
    //   // setFaxNumber(FaxNumber);
    //   // setWebsiteUrl(WebsiteUrl);
    //   // handleNext()
    //   setContactInfoState(PhoneNumber, PhoneExtension, FaxNumber, WebsiteUrl);
    //   if (nextOrBack === "next") {
    //     handleNext();
    //     handleComplete();
    //   } else {
    //     handleBack();
    //   }
    // }
    if (!allRequiredFieldFilled) {
      toast.error("Please enter mandatory fields", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  const validatePrimaryUserInfoForm = (
    firstName,
    lastName,
    title,
    phoneNumber,
    emailAddress,
    password,
    confirmPassword
  ) => {
    if (
      (typeof firstName == "undefined" || firstName.length == 0) &&
      (typeof confirmPassword == "undefined" || confirmPassword.length == 0) &&
      (typeof password == "undefined" || password.length == 0) &&
      (typeof phoneNumber == "undefined" || phoneNumber.length == 0) &&
      (typeof lastName == "undefined" || lastName.length == 0) &&
      (typeof title == "undefined" || title.length == 0) &&
      (typeof emailAddress == "undefined" || emailAddress.length == 0)
    ) {
      setOpenError(true);
      setFirstNameError("error");
      setLastNameError("error");
      setTitleError("error");
      setEmailAddressError("Please enter email address");
      setPasswordError("New password is required!");
      setconfirmPasswordError("Confirm password is required!");
    } else if (typeof firstName == "undefined" || firstName.length == 0) {
      setOpenError(true);
      setFirstNameError("error");
    } else if (typeof lastName == "undefined" || lastName.length == 0) {
      setOpenError(true);
      setLastNameError("error");
    } else if (typeof emailAddress == "undefined" || emailAddress.length == 0) {
      setOpenError(true);
      setEmailAddressError("Please enter email address");
    } else if (
      typeof emailAddressError != "undefined" &&
      emailAddressError != ""
    ) {
      //error
    } else if (typeof password == "undefined" || password.length == 0) {
      setOpenError(true);
      setPasswordError("New password is required!");
    } else if (
      typeof confirmPassword == "undefined" ||
      confirmPassword.length == 0
    ) {
      setOpenError(true);
      setconfirmPasswordError("Confirm password is required!");
    } else if (
      confirmPasswordError != undefined &&
      confirmPasswordError != ""
    ) {
      //password error
    } else if (passwordError != undefined && passwordError != "") {
      //password error
    }
    // else if (typeof phoneNumber == 'undefined' || phoneNumber.length == 0) {
    //   setOpenError(true);
    //   setPhon eNumberErrorPrimary("error");
    // }
    else if (typeof lastName == "undefined" || lastName.length == 0) {
      setOpenError(true);
      setLastNameError("error");
    } else if (typeof title == "undefined" || title.length == 0) {
      setOpenError(true);
      setTitleError("error");
    } else if (phoneNumberError != "" || primaryPhoneNumberError != "") {
      //error
    } else {
      return true;
    }
    return false;
  };

  const setPrimaryUserInfoState = (
    firstName,
    lastName,
    title,
    phoneNumber,
    emailAddress,
    password,
    confirmPassword,
    checkBoxStatus
  ) => {
    setfirstName(firstName);
    setlastName(lastName);
    settitle(title);
    setphoneNumber(phoneNumber);
    setemailAddress(emailAddress);
    setpassword(password);
    setconfirmPassword(confirmPassword);
    setCheckBoxStatus(checkBoxStatus);
  };

  const setPrimaryUserInfoForm = (
    firstName,
    lastName,
    title,
    phoneNumber,
    emailAddress,
    password,
    confirmPassword,
    nextOrBack,
    checkBoxStatus
  ) => {
    const allRequiredFieldFilled = validatePrimaryUserInfoForm(
      firstName,
      lastName,
      title,
      phoneNumber,
      emailAddress,
      password,
      confirmPassword
    );
    setPrimaryUserInfoState(
      firstName,
      lastName,
      title,
      phoneNumber,
      emailAddress,
      password,
      confirmPassword,
      checkBoxStatus
    );
    if (nextOrBack === "next" && allRequiredFieldFilled) {
      setAllFieldUpdated(true);
      handleComplete();
    } else if (nextOrBack === "back") {
      handleBack();
      return;
    }
    // var allRequiredFieldFilled = false;
    // if (
    //   (typeof firstName == "undefined" || firstName.length == 0) &&
    //   (typeof confirmPassword == "undefined" || confirmPassword.length == 0) &&
    //   (typeof password == "undefined" || password.length == 0) &&
    //   (typeof phoneNumber == "undefined" || phoneNumber.length == 0) &&
    //   (typeof lastName == "undefined" || lastName.length == 0) &&
    //   (typeof title == "undefined" || title.length == 0) &&
    //   (typeof emailAddress == "undefined" || emailAddress.length == 0)
    // ) {
    //   setOpenError(true);
    //   setFirstNameError('error');
    //   setLastNameError('error');
    //   setTitleError('error');
    //   setEmailAddressError("Please enter email address");
    //   setPasswordError("New password is required!");
    //   setconfirmPasswordError("Confirm password is required!");
    // }
    //  else if (typeof firstName == 'undefined' || firstName.length == 0) {
    //   setOpenError(true);
    //   setFirstNameError('error');
    // }
    // else if (typeof lastName == "undefined" || lastName.length == 0) {
    //   setOpenError(true);
    //   setLastNameError("error");
    // } else if (typeof emailAddress == "undefined" || emailAddress.length == 0) {
    //   setOpenError(true);
    //   setEmailAddressError("error");
    // } else if (typeof password == "undefined" || password.length == 0) {
    //   setOpenError(true);
    //   setPasswordError("New password is required!");
    // }  else if (typeof confirmPassword == "undefined" || confirmPassword.length == 0) {
    //   setOpenError(true);
    //   setconfirmPasswordError("Confirm password is required!");
    // }
    // else if(confirmPasswordError != '' || passwordError != ''){
    //   //password error
    //   debugger;
    // }
    // // else if (typeof phoneNumber == 'undefined' || phoneNumber.length == 0) {
    // //   setOpenError(true);
    // //   setPhon eNumberErrorPrimary("error");
    // // }
    // else if (typeof lastName == "undefined" || lastName.length == 0) {
    //   setOpenError(true);
    //   setLastNameError("error");
    // } else if (typeof title == "undefined" || title.length == 0) {
    //   setOpenError(true);
    //   setTitleError("error");
    // } else if (phoneNumberError != "" || primaryPhoneNumberError != "") {
    //   //error
    // } else {
    //   allRequiredFieldFilled = true;
    //   // setfirstName(firstName);
    //   // setlastName(lastName);
    //   // settitle(title);
    //   // setphoneNumber(phoneNumber);
    //   // setemailAddress(emailAddress);
    //   // setpassword(password);
    //   // setconfirmPassword(confirmPassword);
    //   // setAllFieldUpdated(true);
    //   setPrimaryUserInfoState(
    //     firstName,
    //     lastName,
    //     title,
    //     phoneNumber,
    //     emailAddress,
    //     password,
    //     confirmPassword
    //   );
    //   if (nextOrBack === "next") {
    //     setAllFieldUpdated(true);
    //     handleComplete();
    //   } else {
    //     handleBack();
    //   }
    // }
    if (!allRequiredFieldFilled) {
      toast.error("Please enter mandatory fields", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  useEffect(() => {
    if (allFieldUpdated) {
      if (checkBoxStatus) {
        registerVendorCompany();
      } else {
        setCheckBoxStatusError(
          "Please check the checkbox by accepting terms & conditions"
        );
      }
      setAllFieldUpdated(false);
    }
  }, [allFieldUpdated]);

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStep = (step) => () => {
    setActiveStep(step);
  };

  const handleComplete = () => {
    const newCompleted = completed;
    newCompleted[activeStep] = true;
    setCompleted(newCompleted);
    // handleNext();
  };

  const handleReset = () => {
    setActiveStep(0);
    setCompleted({});
  };

  const registerVendorCompany = () => {
    setDis(true);
    let item = {
      name: legalName,
      address1: addressLine1Value,
      address2: "",
      address3: "",
      state: StateSelectedForm,
      city: CitesForm,
      zip: ZipCodeForm,
      country: CountrySelectedForm,
      phoneNumber: PhoneNumber,
      faxNumber: FaxNumber,
      websiteURL: WebsiteUrl,
      federalIDNumber: "",
      firstName: firstName,
      lastName: lastName,
      mobileNumber: phoneNumber,
      contactTitle: title,
      email: emailAddress,
      password: password,
      confirmPassword: confirmPassword,
      invitationId: invitationId,
      checkBoxStatus: checkBoxStatus,
      principalCompanyOfficerName: principalValue,
      taxID: taxIdValue,
      extNumber: PhoneExtension,
      countryType: 0,
      language: languageForm,
      geographicArea: [RegionsForm],
      city: CitesForm,
    };
    axios
      .post(
        BaseUrl.baseUrl + BaseUrl.registration.vendorRegistration,
        JSON.stringify(item),
        BaseUrl.apiHeaders
      )
      .then((response) => {
        if (response?.data?.responseMessage == "Success") {
          setRegistrationSuccessfull(true);
          setDis(false);
          toast.success(response.data.responseMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else {
          setOpen(true);
          setDis(false);
          toast.error(response.data.responseMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
      });
  };

  function getStepContent(step) {
    switch (step) {
      case 0:
        return (
          <BusinessInformation
            languageContent={props.content}
            legalNameErrorFlag={legalNameError}
            taxIdErrorFlag={taxIdError}
            companyPrincipleErrorFlag={companyPrincipleError}
            setLegalNameError={setLegalNameError}
            setTaxIdError={setTaxIdError}
            setCompanyPrincipalError={setCompanyPrincipalError}
            setUserDataFetched={setUserDataFetched}
            data={{
              legalName: legalName,
              taxIdValue: taxIdValue,
              principalNameValue: principalValue,
              userDataFetched: userDataFetched,
              setBusinessInfostates: setBusinessInfostates.bind(this),
            }}
          />
        );
      case 1:
        return (
          <AddressInfo
            languageContent={props.content}
            addressLine1ValueErrorFlag={addressLine1ValueError}
            zipCodeFormErrorFlag={zipCodeFormError}
            setAddressLine1ValueError={setAddressLine1ValueError}
            setZipCodeFormError={setZipCodeFormError}
            cityValueErrorFlag={cityValueError}
            setCityValueError={setCityValueError}
            setCountrySelectedFormError={setCountrySelectedFormError}
            data={{
              addressLine1Value: addressLine1Value,
              CountrySelectedForm: CountrySelectedForm,
              StateSelectedForm: StateSelectedForm,
              CitesForm: CitesForm,
              ZipCodeForm: ZipCodeForm,
              languageForm: languageForm,
              RegionsForm: RegionsForm,
              setAddressInfoStates: setAddressInfoStates.bind(this),
            }}
          />
        );
      case 2:
        return (
          <ContactInfo
            languageContent={props.content}
            phoneNumberErrorFlag={phoneNumberError}
            phoneExtensionErrorFlag={phoneExtensionError}
            faxNumberErrorFlag={faxNumberError}
            WebsiteUrlErrorFlag={WebsiteUrlError}
            setPhoneNumberError={setPhoneNumberError}
            setFaxNumberError={setFaxNumberError}
            setPhoneExtensionError={setPhoneExtensionError}
            data={{
              PhoneNumber: PhoneNumber,
              PhoneExtension: PhoneExtension,
              FaxNumber: FaxNumber,
              WebsiteUrl: WebsiteUrl,
              setContactInformationForm: setContactInformationForm.bind(this),
            }}
          />
        );
      case 3:
        return (
          <PrimaryUserInfo
            languageContent={props.content}
            firstNameErrorFlag={firstNameError}
            lastNameErrorFlag={lastNameError}
            titleErrorFlag={titleError}
            passwordErrorFlag={passwordError}
            confirmPasswordErrorFlag={confirmPasswordError}
            emailAddressErrorFlag={emailAddressError}
            primayPhoneNumberErrorFlag={primaryPhoneNumberError}
            setPhoneNumberErrorPrimary={setPhoneNumberErrorPrimary}
            setFirstNameError={setFirstNameError}
            setLastNameError={setLastNameError}
            setTitleError={setTitleError}
            setEmailAddressError={setEmailAddressError}
            setPasswordError={setPasswordError}
            setconfirmPasswordError={setconfirmPasswordError}
            setCheckBoxStatus={setCheckBoxStatus}
            checkBoxStatusError={checkBoxStatusError}
            setCheckBoxStatusError={setCheckBoxStatusError}
            Dis={Dis}
            data={{
              firstName: firstName,
              lastName: lastName,
              title: title,
              phoneNumber: phoneNumber,
              emailAddress: emailAddress,
              password: password,
              confirmPassword: confirmPassword,
              checkBoxStatus: checkBoxStatus,
              setPrimaryUserInfoForm: setPrimaryUserInfoForm.bind(this),
            }}
          />
        );
      default:
        return;
    }
  }

  if (registrationSuccessfull) {
    return <RegistrationSuccess />;
  }

  return (
    <div className="first-verify__registerationContainer">
      <ToastContainer />
      <Button
        variant="outlined"
        className="login-button-backtologin"
        sx={{ width: "200px" }}
        onClick={() => navigate("/")}
      >
        <ArrowBackIcon />
        Back to Login
      </Button>
      <div className="first-verify__inputContainerRegisteration">
        <div className="first-verify__logo"></div>
        <h1 className="registerationCompanyHeader">
          {props.content.newRegistration.companyRegistration}
        </h1>
        {/* <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
            Registration Successful!
          </Alert>
        </Snackbar>
        <Snackbar open={openError} autoHideDuration={6000} onClose={handleClose}>
          <Alert severity="error" onClose={handleClose} >{props.content.newRegistration.completeRequired}</Alert>
        </Snackbar> */}

        <Stack sx={{ width: "100%" }} spacing={4}>
          <Stepper
            activeStep={activeStep}
            alternativeLabel
            connector={<ColorlibConnector />}
          >
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>

          {/* <Stepper
            alternativeLabel
            activeStep={activeStep}
            connector={<ColorlibConnector />}
          >
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel StepIconComponent={ColorlibStepIcon}>{label}</StepLabel>
              </Step>
            ))}
          </Stepper> */}

          <div>
            {allStepsCompleted() ? (
              <React.Fragment>
                <Typography sx={{ mt: 2, mb: 1 }}>
                  All steps completed - you&apos;re finished
                </Typography>
                <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                  <Box sx={{ flex: "1 1 auto" }} />
                  <Button onClick={handleReset}>Reset</Button>
                </Box>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <Typography sx={{ mt: 2, mb: 1 }}>
                  {getStepContent(activeStep)}
                </Typography>
              </React.Fragment>
            )}
          </div>
        </Stack>
      </div>
      <Footer />
    </div>
  );
}
